import React from 'react'

export function SkStopPropagation(props: { children: React.ReactNode }) {
  return (
    <span className="inline-flex" onClick={e => e.stopPropagation()}>
      {props.children}
    </span>
  )
}
